import { SCORING_RESET_LTV } from "../constants";

export const scoringResetLtvRedux = () => async (dispatch: any) => {
  dispatch({ type: SCORING_RESET_LTV });
};
